window.addEventListener('DOMContentLoaded', loadProductSwatches())

function loadProductSwatches() {
  // console.log('loaded Swatch JS:')
  const isProductTemplate = document.body.classList.contains('template-product')

  if (!isProductTemplate) {
    const sizeFieldset = document.querySelector('fieldset[data-handle="size"]');
    if (!sizeFieldset) return;

    sizeFieldset.addEventListener('change', (e) => {
      if (e.target.tagName === 'INPUT') {
        // console.log('xxx changed input', e.target)
        const productHandle = e.target.dataset.productHandle
        const value = e.target.value
        const formInputs = e.target.closest('.product-information').querySelectorAll('input[name="id"]')

        // Handle ATC error messages
        const errorForm = document.querySelector('.product-form__error-message-wrapper')
        if (!errorForm.getAttribute('hidden')) {
          errorForm.setAttribute('hidden', '')
        }
        
        // Fetch the product data
        fetch(`/products/${productHandle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
          }
          return response.json(); // Return the response as JSON
        })
        .then(productData => {
          //console.log('xxx productData:', productData)
          const variants = productData.variants
          const matchingVariant = variants.find(variant => variant.option2 === value)

          if (matchingVariant && formInputs.length) {
            formInputs.forEach(input => {
              input.value = matchingVariant.id
            })
          }

        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
      }
    })
  } else {

    // Load Frenzy Bundle on Quick View
    if (document.getElementById('Product-Drawer-Content')) {
      const frenzyProductId = document.querySelector('input[name="product-id"]')?.value.trim();
      const frenzyVariantId = document.querySelector('input[name="id"]')?.value.trim();
      product_id_Frenzy = frenzyProductId
      variant_id_Frenzy = frenzyVariantId
      if (product_id_Frenzy && variant_id_Frenzy) {
        frenzy_sku = `${product_id_Frenzy}_${variant_id_Frenzy}`
      }
      
      // frenzyScriptReload()
      // if (document.querySelector('.frenzy_bundle_id')) {
      //   $frenzy_bundle_event()
      // }
    }

    const colorFieldset = document.querySelector('fieldset[data-colorswatches="true"]')
    const sizeFieldset = document.querySelector('.product-information--inner fieldset[data-handle="size"]');
    const dominationFieldset = document.querySelector('fieldset[data-handle="denominations"]')
    let sizeSwatches = sizeFieldset ? sizeFieldset.querySelectorAll('input[type="radio"]') : null;
    let isSolidColor = false
    let isPrintColor = false
    // Incremented on every color pick; responses for an older pick are ignored
    // so rapid switching always ends on the last color chosen.
    let latestColorRequest = 0

    if(dominationFieldset) {
      dominationFieldset.addEventListener('change', (e) => {
        if (e.target.tagName === 'INPUT') {
          //console.log(e.target)
          const productHandle = e.target.dataset.productHandle
    
    
          // Fetch the product data
          fetch(`/products/${productHandle}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.json(); // Return the response as JSON
          })
          .then(productData => {

            const value = e.target.value
            dispatchCustomEvent("product:variant-changed", {
              productData: productData
            })
    
            updateProductMedia(productData)
            updateProductInfoDominations(productData, value)
            updateProductAddToCartForm(productData, value)
            
    
          })
          .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
          });
        }
      })
    }

    if(sizeSwatches && sizeSwatches.length > 0) {
    // Get DOMContentLoaded selected Size Swatch Value and Index - Store it Locally
    sizeSwatches.forEach((sizeSwatch, index) => {
      if (sizeSwatch.checked) {
        localStorage.setItem('sizeSwatchValue', sizeSwatch.value)
        localStorage.setItem('sizeSwatchIndex', index)
      }
    })
    }
    

    if(colorFieldset) {
      colorFieldset.addEventListener('change', (e) => {
        if (e.target.tagName === 'INPUT') {
          //console.log(e.target)
          const productHandle = e.target.dataset.productHandle
          const storedSizeValue = localStorage.getItem('sizeSwatchValue')
          const storedSizeIndex = localStorage.getItem('sizeSwatchIndex')
    
          // Check which type of color swatch was selected
          if (e.target.parentNode.classList.contains('solid_swatches')) {
            isSolidColor = true
          } else {
            isSolidColor = false
          }
          if (e.target.parentNode.classList.contains('print_swatches')) {
            isPrintColor = true
          } else {
            isPrintColor = false
          }

          const colorRequest = ++latestColorRequest

          // Refresh the Product Details / Features & Materials tabs for the new color
          updateProductTabs(productHandle, colorRequest)

          // Fetch the product data
          fetch(`/products/${productHandle}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.json(); // Return the response as JSON
          })
          .then(productData => {
            // A newer color has been picked since this request started
            if (colorRequest !== latestColorRequest) return

            dispatchCustomEvent("product:variant-changed", {
              productData: productData
            })
    
            updateProductMedia(productData)
            updateProductInfo(productData, storedSizeValue, storedSizeIndex, isSolidColor, isPrintColor)
            updateProductAddToCartForm(productData, storedSizeValue)

          //console.log("Calling updateSizeChart() after color change");
          updateSizeChart(productData);
    
          })
          .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
          });
        }
      })
    }
  

    if(sizeFieldset) { 
      sizeFieldset.addEventListener('change', (e) => {
        if (e.target.tagName === 'INPUT') {
          //console.log('zzz', e.target)
          const productHandle = e.target.dataset.productHandle
          const sizeIndex = e.target.dataset.index
          const value = e.target.value

          // Handle ATC error messages
          const errorForm = document.querySelector('.product-form__error-message-wrapper')
          if (!errorForm.getAttribute('hidden')) {
            errorForm.setAttribute('hidden', '')
          }

          localStorage.setItem('sizeSwatchValue', value)
          localStorage.setItem('sizeSwatchIndex', sizeIndex)
          
          // Fetch the product data
          fetch(`/products/${productHandle}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.json(); // Return the response as JSON
          })
          .then(productData => {

            dispatchCustomEvent("product:variant-changed", {
              productData: productData
            })

            updateProductInfo(productData, value, sizeIndex, isSolidColor, isPrintColor)
            updateProductAddToCartForm(productData, value)

          createNewSizeSwatches(productData, sizeIndex);
          updateSizeChart(productData);

          })
          .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
          });
        }
      })
    }

    // Begin Functions -------------------------------------------------------------

    // Re-render the tabbed content of each Content + Progress bars section
    // (Product Details, Features & Materials) from the selected color's own
    // product page, so it matches what that page shows when opened directly.
    function updateProductTabs(productHandle, colorRequest) {
      const tabbedContents = Array.from(document.querySelectorAll('.content-progress-section tabbed-content'))
      if (!tabbedContents.length) return

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'

      tabbedContents.forEach(tabbedContent => {
        const sectionEl = tabbedContent.closest('.shopify-section')
        if (!sectionEl || !sectionEl.id) return
        const sectionId = sectionEl.id.replace('shopify-section-', '')

        fetch(`${root}products/${encodeURIComponent(productHandle)}?section_id=${encodeURIComponent(sectionId)}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
          }
          return response.text()
        })
        .then(html => {
          // A newer color has been picked since this request started
          if (colorRequest !== latestColorRequest) return

          const doc = new DOMParser().parseFromString(html, 'text/html')
          const newPanels = doc.querySelectorAll('tabbed-content .tabbed-content--content')
          const currentPanels = tabbedContent.querySelectorAll('.tabbed-content--content')
          if (newPanels.length !== currentPanels.length) return

          // Swap panel contents only, keeping the panels themselves (and the
          // active tab) in place.
          currentPanels.forEach((panel, index) => {
            panel.innerHTML = newPanels[index].innerHTML
          })
        })
        .catch(error => {
          console.error('There was a problem updating the product tabs:', error);
        });
      })
    }

    function updateProductMedia(productData) {
      const mediaSlider = document.getElementById('Product-Slider')
      const sectionId = mediaSlider.getAttribute('data-section-id')

      // Set Active Media
      const flkty = Flickity.data(mediaSlider)
      const firstMediaId = productData.media[0].id
      const newSlides = createNewSlides(productData, sectionId)
        
      if (flkty) {
        mediaSlider.selectCell(firstMediaId);
        // Update Thumbnails
        flkty.remove(flkty.getCellElements());
        flkty.append(newSlides);
        flkty.select( 0, false, true );
        updateThumbnails(productData, sectionId)
        addZoomToImages()
      }
    }

function updateSizeChart(productData) {
  // This doesn't work -ACDC
  return;
  const sizeChartContainer = document.querySelector('.product-form__input[data-handle="size"] .form__label');
  const sizeChartModal = document.querySelector('.product-popup-modal__content-info');
  const existingModal = document.querySelector('#PopupModal-variant_picker');

  if (!sizeChartContainer || !sizeChartModal || !existingModal) {
    console.warn("⚠️ Missing elements for size chart update");
    return;
  }

  // Get metafield content properly
  const sizeChartContent = product?.metafields?.custom?.size_chart?.value;

  // Remove existing button to prevent duplicates
  const existingOpener = document.querySelector('.product-popup-modal__opener');
  if (existingOpener) existingOpener.remove();

  // Create new modal opener
  const modalOpener = document.createElement('modal-opener');
  modalOpener.className = "product-popup-modal__opener no-js-hidden";
  modalOpener.setAttribute("data-modal", "#PopupModal-variant_picker");

  const button = document.createElement('button');
  button.id = "ProductPopup-variant_picker";
  button.className = "product-popup-modal__button";
  button.type = "button";
  button.setAttribute("aria-haspopup", "dialog");
  button.innerHTML = `<span>Size Chart</span>`;

  modalOpener.appendChild(button);
  sizeChartContainer.appendChild(modalOpener);

  // Insert correct size chart content
  sizeChartModal.innerHTML = sizeChartContent;

  // **Manually reattach modal-opener event**
  const newButton = document.querySelector('#ProductPopup-variant_picker');
  newButton.addEventListener('click', () => {
    const modal = document.querySelector(newButton.parentElement.getAttribute('data-modal'));
    if (modal) modal.show(newButton);
  });
}

    
    function updateProductInfoDominations(productData, value) {
      const matchingVariant = productData.variants.find(variant => variant.option1 === value)

      //console.log('Product Data:', productData)
      //console.log('Matched Variant:', matchingVariant)

      // Update product title
      const title = document.querySelector('.product-title')
      title.innerText = productData.title

      // Update product price with badges - FRENZY - sale handled by tag
      const priceContainer = document.querySelector('.product-price-container')
      const sectionId = document.getElementById('Product-Slider').getAttribute('data-section-id')
      const saleTag = productData.tags.find(tag => tag.startsWith('sale-online-'));
      const originalPrice = window.formatMoney(matchingVariant.price, window.theme.settings.money_with_currency_format)


      if (saleTag) {
        // Extract the percentage part of the tag
        const percentOff = parseInt(saleTag.split('sale-online-')[1]);

        if (!isNaN(percentOff)) {
          const discountedPrice = window.formatMoney(productData.price - (percentOff / 100 * productData.price), window.theme.settings.money_with_currency_format)

          const newPriceMarkup = `
            <div class="no-js-hidden" id="price-${sectionId}">
              <span class="price">
                <del>
                  <span class="amount">${originalPrice}</span>
                </del>
                <ins>
                  <span class="amount">${discountedPrice}</span>
                </ins>
                <small class="unit-price hidden">
                  <span></span>
                  <span class="unit-price-separator">/</span>
                  <span> </span>
                </small>
                <span class="badges">
                  <span class="badge onsale">Save ${percentOff}%</span>
                </span>
              </span>
            </div>
          `
          priceContainer.innerHTML = ''
          priceContainer.innerHTML = newPriceMarkup
        }
      } else {
        const newPriceMarkup = `
          <div class="no-js-hidden" id="price-${sectionId}">
            <span class="price">
              <ins>
                <span class="amount">${originalPrice}</span>
              </ins>
              <small class="unit-price hidden">
                <span></span>
                <span class="unit-price-separator">/</span>
                <span> </span>
              </small>
              <span class="badges"></span>
            </span>
          </div>
        `
        priceContainer.innerHTML = ''
        priceContainer.innerHTML = newPriceMarkup
      }


      // Handle inventory level
      const inventoryContainer = document.getElementById(`inventory-${sectionId}`)
      if (matchingVariant.inventory_quantity > 0 && matchingVariant.inventory_quantity <= 5) {
        let scale = matchingVariant.inventory_quantity * 5
        if (scale === 5) {
          scale = `0${scale}`
        }
        const inventoryMarkup = `
          <div class="product-inventory-notice product-inventory-notice--low">
            <div class="product-inventory-notice--text">
              <div class="product-inventory-notice--pulse"></div>
              ${matchingVariant.inventory_quantity} in stock
            </div>
            <div class="product-inventory-notice--bar" style="--inventory-scale:0.${scale}">
              <span></span>
            </div>
          </div>
        `
        if (inventoryContainer) {
          inventoryContainer.innerHTML = ''
          inventoryContainer.innerHTML = inventoryMarkup  
        }
        
      } else {
        if (inventoryContainer) {
          inventoryContainer.innerHTML = ''  
        }
        
      }
    }

    function updateProductInfo(productData, storedSizeValue, storedSizeIndex, isSolidColor, isPrintColor) {
      const matchingVariant = productData.variants.find(variant => variant.option2 === storedSizeValue)

      // console.log('Product Data:', productData)
      // console.log('Matched Variant:', matchingVariant)

      // Update product title
      const title = document.querySelector('.product-title')
      title.innerText = productData.title

      // Update product price with badges - FRENZY - sale handled by tag
      const priceContainer = document.querySelector('.product-price-container')
      const sectionId = document.getElementById('Product-Slider').getAttribute('data-section-id')
      const saleTag = productData.tags.find(tag => tag.startsWith('sale-online-'));
      const originalPrice = window.formatMoney(productData.price, window.theme.settings.money_with_currency_format)

      if (saleTag) {
        // Extract the percentage part of the tag
        const percentOff = parseInt(saleTag.split('sale-online-')[1]);

        if (!isNaN(percentOff)) {
          const discountedPrice = window.formatMoney(productData.price - (percentOff / 100 * productData.price), window.theme.settings.money_with_currency_format)

          const newPriceMarkup = `
            <div class="no-js-hidden" id="price-${sectionId}">
              <span class="price">
                <del>
                  <span class="amount">${originalPrice}</span>
                </del>
                <ins>
                  <span class="amount">${discountedPrice}</span>
                </ins>
                <small class="unit-price hidden">
                  <span></span>
                  <span class="unit-price-separator">/</span>
                  <span> </span>
                </small>
                <span class="badges">
                  <span class="badge onsale">Save ${percentOff}%</span>
                </span>
              </span>
            </div>
          `
          priceContainer.innerHTML = ''
          priceContainer.innerHTML = newPriceMarkup
        }
      } else {
        const newPriceMarkup = `
          <div class="no-js-hidden" id="price-${sectionId}">
            <span class="price">
              <ins>
                <span class="amount">${originalPrice}</span>
              </ins>
              <small class="unit-price hidden">
                <span></span>
                <span class="unit-price-separator">/</span>
                <span> </span>
              </small>
              <span class="badges"></span>
            </span>
          </div>
        `
        priceContainer.innerHTML = ''
        priceContainer.innerHTML = newPriceMarkup
      }

      // Handle inventory level
      const inventoryContainer = document.getElementById(`inventory-${sectionId}`)
      if (inventoryContainer) {
        if (matchingVariant.inventory_quantity > 0 && matchingVariant.inventory_quantity <= 5) {
          let scale = matchingVariant.inventory_quantity * 5
          if (scale === 5) {
            scale = `0${scale}`
          }
          const inventoryMarkup = `
            <div class="product-inventory-notice product-inventory-notice--low">
              <div class="product-inventory-notice--text">
                <div class="product-inventory-notice--pulse"></div>
                ${matchingVariant.inventory_quantity} in stock
              </div>
              <div class="product-inventory-notice--bar" style="--inventory-scale:0.${scale}">
                <span></span>
              </div>
            </div>
          `
          inventoryContainer.innerHTML = ''
          inventoryContainer.innerHTML = inventoryMarkup
        } else {
          inventoryContainer.innerHTML = ''
        }
      }


      // Create new size swatches
      createNewSizeSwatches(productData, storedSizeIndex)

      // Update ATC Button + Sold out badge
      const ATCButton = document.getElementById('AddToCart')
      const badgeContainer = document.querySelector('span.badges')
      const oosBadge = badgeContainer.querySelector('span.out-of-stock')

      if (ATCButton && !matchingVariant.available) {
        ATCButton.setAttribute('disabled', 'disabled')
        ATCButton.querySelector('span.single-add-to-cart-button--text').innerText = window.theme.variantStrings.soldOut
      } else {
        ATCButton.removeAttribute('disabled')
        ATCButton.querySelector('span.single-add-to-cart-button--text').innerText = window.theme.variantStrings.addToCart
      }

      if (badgeContainer && !matchingVariant.available && !oosBadge) {
        const badge = document.createElement('span')
        badge.className = 'badge out-of-stock'
        badge.innerText = 'Sold out'
        badgeContainer.append(badge)
      } else if (badgeContainer && matchingVariant.available && oosBadge) {
        oosBadge.remove()
      }

      // Update Option Labels
      const solidContainer = document.querySelector('.solid_swatches')
      const solidOptionLabel = solidContainer?.querySelector('span.form__label__value')
      const printContainer = document.querySelector('.print_swatches')
      const printOptionLabel = printContainer?.querySelector('span.form__label__value')

      if (isSolidColor) {
        if (solidOptionLabel) {
          solidOptionLabel.innerText = ` : ${matchingVariant.option1}`
        }
        if (printOptionLabel) {
          printOptionLabel.innerText = ''
        }
      } else if (isPrintColor) {
        if (solidOptionLabel) {
          solidOptionLabel.innerText = ''
        }
        if (printOptionLabel) {
          printOptionLabel.innerText = ` : ${matchingVariant.option1}`
        }
      }

      // Update FRENZY Bundles
      product_id_Frenzy = productData.id
      variant_id_Frenzy = matchingVariant.id
      if (product_id_Frenzy && variant_id_Frenzy) {
        frenzy_sku = `${product_id_Frenzy}_${variant_id_Frenzy}`
      }
      
      frenzyScriptReload()
      if (document.querySelector('.frenzy_bundle_id')) {
        $frenzy_bundle_event()
      }

      // Update Product Description
      const descriptionContainerDesktop = document.querySelector('.collapsible-content-desktop[data-product-template="true"] .section-description-wrapper')
      const descriptionContainerMobile = document.querySelector('.collapsible-content-mobile[data-product-template="true"] .section-description-wrapper')

      if (descriptionContainerDesktop) {
        descriptionContainerDesktop.innerHTML = ''
        descriptionContainerDesktop.innerHTML = productData.description
      }
      if (descriptionContainerMobile) {
        descriptionContainerMobile.innerHTML = ''
        descriptionContainerMobile.innerHTML = productData.description
      }

      // Update Product Features Accordions ? Is this Metafields?
    }

    function updateProductAddToCartForm(productData, value) {
      let matchingVariant = productData.variants.find(variant => variant.option2 === value);
      if (!matchingVariant)  {
        matchingVariant = productData.variants.find(variant => variant.option1 === value);
      }
      const variantId = matchingVariant.id
      const productSlider = document.getElementById('Product-Slider')
      const sectionId = productSlider.getAttribute('data-section-id')
      const form = document.getElementById(`product-form-${sectionId}`)

      // Update Variant ID for Add to Cart
      form.querySelector('input[name="id"]').value = variantId

      // Update URL with Variant ID Parameter
      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('variant')) {
        currentUrl.searchParams.set('variant', variantId);
      } else {
        currentUrl.searchParams.append('variant', variantId);
      }

      const currentParams = currentUrl.search; // Preserve any existing query parameters
      const currentPath = currentUrl.pathname; // Get the current path

      // Check if the current path includes '/products/'
      let newPath;
      if (currentPath.includes('/products/')) {
        newPath = currentPath.replace(/\/products\/[^/]+/, `/products/${productData.handle}`);
      }
      const newUrl = `${newPath}${currentParams}`;
      window.history.replaceState({}, '', newUrl);

    }

    function createNewSlides(productData, sectionId) {
      return productData.media.map((media, index) => {
        const slideDiv = document.createElement('div');
        slideDiv.id = `Slide-${sectionId}-${media.id}`;
        slideDiv.className = 'product-images__slide is-active';
        slideDiv.setAttribute('data-media-id', `${sectionId}-${media.id}`);

        const mediaDiv = document.createElement('div');
        mediaDiv.className = 'product-single__media product-single__media-image aspect-ratio aspect-ratio--adapt';
        mediaDiv.id = `Media-Thumbnails-${sectionId}-${media.id}`;
        mediaDiv.style.setProperty('--padding-bottom', '129.62962962962962%');

        const zoomLink = document.createElement('a')
        zoomLink.href = media.src
        zoomLink.className = 'product-single__media-zoom'
        zoomLink.setAttribute('data-msrc', media.src + '&width=20')
        zoomLink.setAttribute('data-h', media.height)
        zoomLink.setAttribute('data-w', media.width)
        zoomLink.setAttribute('target', '_blank')
        zoomLink.setAttribute('tab-index', '-1')
        zoomLink.title = 'Zoom'
        zoomLink.setAttribute('data-index', index)

        zoomLink.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.125 3.75H16.25V6.875" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M11.875 8.125L16.25 3.75" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M6.875 16.25H3.75V13.125" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M8.125 11.875L3.75 16.25" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M16.25 13.125V16.25H13.125" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M11.875 11.875L16.25 16.25" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M3.75 6.875V3.75H6.875" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M8.125 8.125L3.75 3.75" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        `

        const img = document.createElement('img');
        img.className = 'lazyautosizes';
        img.width = media.width;
        img.height = media.height;
        img.setAttribute('data-sizes', 'auto');
        img.src = media.src;
        img.setAttribute('data-srcset', `${media.src} 345w,${media.src} 610w,${media.src} 1220w`);
        img.setAttribute('fetchpriority', 'auto');
        img.alt = media.alt;
        img.sizes = '610px';
        img.srcset = `${media.src} 345w,${media.src} 610w,${media.src} 1220w`

        const noscript = document.createElement('noscript');
        const noscriptImg = document.createElement('img');
        noscriptImg.width = media.width;
        noscriptImg.height = media.height;
        noscriptImg.sizes = 'auto';
        noscriptImg.src = media.src;
        noscriptImg.srcset = `${media.src} 345w,${media.src} 610w,${media.src} 1220w`;
        noscriptImg.alt = media.alt;
        noscriptImg.setAttribute('fetchpriority', 'auto');
        noscriptImg.setAttribute('loading', 'lazy');

        noscript.appendChild(noscriptImg);

        mediaDiv.appendChild(zoomLink);
        mediaDiv.appendChild(img);
        mediaDiv.appendChild(noscript);

        slideDiv.appendChild(mediaDiv);
        return slideDiv;
      });
    }

    function addZoomToImages() {
      // Add Zoom
      const links = document.querySelectorAll('.product-single__media-zoom');
      const pswpElement = document.querySelectorAll('.pswp')[0];
      const pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true
      };

      links.forEach((link => {
        link.addEventListener('click', (e) => zoomClick(e, link));
      }));

      function buildItems() {
        const slider = document.getElementById('Product-Slider')
        const activeImages = Array.from(slider.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));
    
        return activeImages.map((item) => {
          let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);
    
          let activelink = item.querySelector('.product-single__media-zoom');
    
          activelink.dataset.index = index;
          return {
            src: activelink.getAttribute('href'),
            msrc: activelink.dataset.msrc,
            w: activelink.dataset.w,
            h: activelink.dataset.h
          };
        });
      }

      function zoomClick(e, link) {
        const items = buildItems()
        pswpOptions.index = parseInt(link.dataset.index, 10);
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, pswpOptions);
          pswp.listen('firstUpdate', function () {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      }
    }

    function createNewThumbnail(media, sectionId) {
      const thumbDiv = document.createElement('div');
      thumbDiv.id = `Thumb-${sectionId}-${media.id}`;
      thumbDiv.className = 'product-thumbnail is-active product-images__slide-item--variant';

      const img = document.createElement('img');
      img.className = 'lazyautosizes';
      img.width = media.width;
      img.height = media.height;
      img.setAttribute('data-sizes', 'auto');
      img.src = media.src;
      img.setAttribute('data-srcset', `${media.src} 160w`);
      img.setAttribute('fetchpriority', 'auto');
      img.alt = media.alt;
      img.sizes = '80px';
      img.srcset = `${media.src} 160w`;

      const noscript = document.createElement('noscript');
      const noscriptImg = document.createElement('img');
      noscriptImg.width = media.width;
      noscriptImg.height = media.height;
      noscriptImg.sizes = 'auto';
      noscriptImg.src = media.src;
      noscriptImg.srcset = `${media.src} 160w`;
      noscriptImg.alt = media.alt;
      noscriptImg.setAttribute('fetchpriority', 'auto');
      noscriptImg.setAttribute('loading', 'lazy');

      noscript.appendChild(noscriptImg);
      thumbDiv.appendChild(img);
      thumbDiv.appendChild(noscript);

      return thumbDiv;
    }

    function updateThumbnails(productData, sectionId) {
      const thumbnailContainer = document.getElementById('Product-Thumbnails')
      thumbnailContainer.innerHTML = ''

      productData.media.forEach((media) => {
        const thumbnail = createNewThumbnail(media, sectionId);
        thumbnailContainer.appendChild(thumbnail);
      });

      attachThumbnailEvents(thumbnailContainer);
    }

    function attachThumbnailEvents(thumbnailContainer) {
      const thumbnails = thumbnailContainer.querySelectorAll('.product-thumbnail')
      const productSlider = document.getElementById('Product-Slider')
      productSlider.reInit();
      if (thumbnails.length > 0) {
        const firstThumbnail = thumbnails[0];
        firstThumbnail.classList.add('is-initial-selected');
      }
    }

    function addSizeChartButton(fieldset) {
  // Remove existing size chart button (prevents duplicates)
  const existingButton = document.querySelector('.product-popup-modal__opener');
  if (existingButton) {
    existingButton.remove();
  }

  // Create new modal-opener wrapper
  const modalOpener = document.createElement('modal-opener');
  modalOpener.className = 'product-popup-modal__opener no-js-hidden';
  modalOpener.setAttribute('data-modal', '#PopupModal-variant_picker');

  // Create button
  const sizeChartButton = document.createElement('button');
  sizeChartButton.id = 'ProductPopup-variant_picker';
  sizeChartButton.className = 'product-popup-modal__button';
  sizeChartButton.type = 'button';
  sizeChartButton.setAttribute('aria-haspopup', 'dialog');
  sizeChartButton.innerHTML = `
    <svg class="icon icon-accordion color-foreground-" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path d="M18.9836 5.32852L14.6715 1.01638L1.01638 14.6715L5.32852 18.9836L18.9836 5.32852ZM15.3902 0.297691C14.9933 -0.0992303 14.3497 -0.0992303 13.9528 0.297691L0.297691 13.9528C-0.0992301 14.3497 -0.0992305 14.9932 0.297691 15.3902L4.60983 19.7023C5.00675 20.0992 5.65029 20.0992 6.04721 19.7023L19.7023 6.04721C20.0992 5.65029 20.0992 5.00675 19.7023 4.60983L15.3902 0.297691Z" fill-rule="evenodd"></path>
      <path d="M11.7863 2.67056C11.9848 2.4721 12.3065 2.4721 12.505 2.67056L14.4237 4.58927C14.6222 4.78774 14.6222 5.1095 14.4237 5.30796C14.2252 5.50642 13.9035 5.50642 13.705 5.30796L11.7863 3.38925C11.5878 3.19079 11.5878 2.86902 11.7863 2.67056Z"></path>
      <path d="M8.93891 5.36331C9.13737 5.16485 9.45914 5.16485 9.6576 5.36331L11.5763 7.28202C11.7748 7.48048 11.7748 7.80225 11.5763 8.00071C11.3779 8.19917 11.0561 8.19917 10.8576 8.00071L8.93891 6.082C8.74045 5.88354 8.74045 5.56177 8.93891 5.36331Z"></path>
      <path d="M6.24307 8.20742C6.44153 8.00896 6.76329 8.00896 6.96175 8.20742L8.88047 10.1261C9.07893 10.3246 9.07893 10.6464 8.88047 10.8448C8.68201 11.0433 8.36024 11.0433 8.16178 10.8448L6.24307 8.92611C6.0446 8.72765 6.0446 8.40588 6.24307 8.20742Z"></path>
      <path d="M3.37296 10.8776C3.57142 10.6791 3.89319 10.6791 4.09165 10.8776L6.01036 12.7963C6.20882 12.9948 6.20882 13.3165 6.01036 13.515C5.8119 13.7134 5.49013 13.7134 5.29167 13.515L3.37296 11.5963C3.1745 11.3978 3.1745 11.076 3.37296 10.8776Z"></path>
    </svg>
    <span>Size Chart</span>
  `;

  modalOpener.appendChild(sizeChartButton);

  // **Append the button inside the fieldset**
  const labelContainer = fieldset.querySelector('.form__label');
  if (labelContainer) {
    labelContainer.appendChild(modalOpener);
    //console.log("✅ Size chart button re-added successfully!");
  } else {
    console.warn("⚠️ Label container not found, button not inserted.");
  }

  // **Manually attach event listener to open modal**
  sizeChartButton.addEventListener('click', () => {
    const modal = document.querySelector(sizeChartButton.parentElement.getAttribute('data-modal'));
    if (modal) {
      modal.show(sizeChartButton);
    } else {
      console.error("🚨 Modal not found!");
    }
  });
}



function createNewSizeSwatches(productData, storedSizeIndex) {
      //console.log('Product Data:', productData)
      const productSlider = document.getElementById('Product-Slider')
      const sectionId = productSlider.getAttribute('data-section-id')
      const fieldset = document.querySelector('fieldset[data-handle="size"]')
      const name = productData.options[1].name
      const position = productData.options[1].position
      const values = productData.options[1].values
      const productHandle = productData.handle

      // Clear old sizes
      fieldset.innerHTML = '<div class="form__label"> Size </div>'

      // Create inputs
      values.forEach((value, index) => {
        const matchingVariant = productData.variants.find(variant => variant.option2 === value); // Find matching variant by option value

        // Create the size swatch input element
        const sizeSwatch = document.createElement('input');
        sizeSwatch.type = 'radio';
        sizeSwatch.id = `${sectionId}-${position}-${index}`;
        sizeSwatch.name = name;
        sizeSwatch.value = value;
        sizeSwatch.form = `product-form-${sectionId}`;
        sizeSwatch.setAttribute('data-product-handle', productHandle);
        sizeSwatch.setAttribute('data-index', index);
        if (parseInt(storedSizeIndex) === index) {
          sizeSwatch.setAttribute('checked', '')
        }

        // Create label for input
        const sizeLabel = document.createElement('label')
        sizeLabel.setAttribute('for', `${sectionId}-${position}-${index}`)
        if (!matchingVariant.available) {
          sizeLabel.className = 'disabled-label'
        }
        
        // Create label span
        const labelSpan = document.createElement('span')
        labelSpan.innerText = value

        // Append elements
        fieldset.append(sizeSwatch)
        sizeLabel.append(labelSpan)
        fieldset.append(sizeLabel)

        // Reinsert the Size Chart Button
        addSizeChartButton(fieldset);
      })
    }
  }
}